<template>
  <div class="selecttree">
    <el-select
      class="main-select-tree"
      ref="selectTree"
      v-model="value"
      style="width: 100%"
      multiple
      :disabled="disabled"
    >
      <el-option
        v-for="item in formatData(list)"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        style="display: none"
      />
      <el-tree
        class="main-select-el-tree"
        ref="selecteltree"
        :data="list"
        :node-key="rowKey"
        highlight-current
        :props="defaultProps"
        @node-click="handleNodeClick"
        @check="hancleCheckClick"
        :show-checkbox="true"
        :check-strictly="true"
        :default-checked-keys="value"
        :check-on-click-node="true"
        :expand-on-click-node="expandOnClickNode"
        default-expand-all
      />
    </el-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "setValue",
  },
  props: {
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 传入嵌套数据
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    rowKey: {
      type: String,
      default: "id",
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          children: "children",
          label: "name",
        };
      },
    },
  },
  data() {
    return {
      expandOnClickNode: true,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.$refs.selecteltree.setCheckedKeys(val);
        });
      },
    },
  },
  methods: {
    // 四级菜单
    formatData(data) {
      let options = [];
      data.forEach((item, key) => {
        options.push({
          label: item[this.defaultProps.label],
          value: item[this.rowKey],
        });
        if (item[this.defaultProps.children]) {
          item[this.defaultProps.children].forEach((items, keys) => {
            options.push({
              label: items[this.defaultProps.label],
              value: items[this.rowKey],
            });
            if (items[this.defaultProps.children]) {
              items[this.defaultProps.children].forEach((itemss, keyss) => {
                options.push({
                  label: itemss[this.defaultProps.label],
                  value: itemss[this.rowKey],
                });
                if (itemss[this.defaultProps.children]) {
                  itemss[this.defaultProps.children].forEach(
                    (itemsss, keysss) => {
                      options.push({
                        label: itemsss[this.defaultProps.label],
                        value: itemsss[this.rowKey],
                      });
                    }
                  );
                }
              });
            }
          });
        }
      });
      return options;
    },
    handleNodeClick(data, node, dom) {
      if (node.disabled) {
        this.$message.error("只能选择子节点");
        return;
      }
      let list = this.$refs.selecteltree.getCheckedKeys();
      this.updateSelectNode(data, list);
      // this.$refs.selectTree.blur();
    },
    hancleCheckClick(data, checked, indeterminate) {
      let list = this.$refs.selecteltree.getCheckedKeys();
      this.updateSelectNode(data, list);
    },
    updateSelectNode(data, list) {
      if (list.length > 3) {
        this.$refs.selecteltree.setChecked(data.id, false);
        this.$message.info("最多选择3个工种");
        return;
      }
      this.$emit("setValue", list);
    },
  },
};
</script>
<style lang="scss">
.main-select-el-tree .el-tree-node .is-current > .el-tree-node__content {
  font-weight: bold;
  color: #ea0e0e;
}

.main-select-el-tree .el-tree-node.is-current > .el-tree-node__content {
  font-weight: bold;
  color: #ea0e0e;
}
</style>
